import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { BpCoreModule } from '../../../../../../../bp-core/src/lib/bp-core.module';
@Component({
  selector: 'bp-image-info-card',
  templateUrl: './bp-image-info-card.component.html',
  styleUrls: ['./bp-image-info-card.component.scss'],
  standalone: true,
  imports: [
    BpCoreModule,
    MatRippleModule,
    NgClass,
    MatButtonModule,
    MatIconModule,
    NgOptimizedImage,
  ],
})
export class BpImageInfoCardComponent implements OnInit {
  @Input() image?: string;
  @Input() imageAlt?: string;
  @Input() responsiveLayout: 'row' | 'col' = 'row';
  @Input() layout: 'row' | 'col' = 'row';
  @Input() arrow = true;
  @Input() roundedImage = true;
  @Input() newVersion = false;
  constructor() {}
  ngOnInit(): void {}
}
